import i18n from 'scoreboard/components/i18n'
import PagesEdit from './pages-edit'
import template from './dialogs-edit-widgets-form.hbs'

const DialogsEditWidgetsForm = PagesEdit.extend({

	tagName: 'form',

	className: 'table-hack display-layout forms-edit-view',

	/** @type {Form} */
	model: null,

	initialize: function(options = {}) {
		PagesEdit.prototype.initialize.call(this, options)
		this.template = template

		this.displayActionTitle = i18n.get('forms.dialog.dialogDisplayActions')
		this.displayActionBannerMsg = i18n.get(
			'forms.actions.dialogDisplayActionsBanner',
			i18n.get('forms.actions.actionsBannerPart2'))
		this.displayActionEmptyMsg = i18n
			.get('forms.actions.emptyDialogDisplay')

		// Avoid showing the dashboard and record list menus options when
		// adding widgets to a dialog
		this.showDashboardAndRecordListMenus = false
	},
})

export default DialogsEditWidgetsForm
DialogsEditWidgetsForm.__filename__ = 'forms/edit/dialogs-edit-widgets-form.js'
